Librarian.CategorySelectWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["onTreeNodeLoaded", "onSelectClicked"],

    options: {
        id: "CategorySelectWindow",
        height: 300,
        padding: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        },
        selectedCategories: null,
        selectedCategoryIDs: null,
        catType: Librarian.catType.file,
        rootCat: 0,
        multiSelect: true
    },

    treeView: null,

    initialize: function(options) {
        this.setOptions(options);

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString("select_category_title");

        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/categoryselect.html";

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();
        this.setupElements();

        var itemEl = this.getElement("categorySelectContainer");
        if (!itemEl)
            return;
        var options = {
            container: itemEl,
            checkBoxes: this.options.multiSelect,
            hideTypes: ["file"],
            catType: this.options.catType,
            rootCat: this.options.rootCat,
            cookieStorage: false,           
        };

        if (Librarian.search.useViewinCategorySelect)
            options.contentView = "SearchCats";

        if ((this.options.catType == Librarian.catType.globalFavorite) && Librarian.specialCategories && Librarian.specialCategories.GlobalFavorites) {
            options.rootCat = Librarian.specialCategories.GlobalFavorites.CatId;
            options.method = "getcg";
        }

        if (typeof Library.getTreeOptions == "function")
            options = Library.getTreeOptions(options);

        this.treeView = new Librarian.TreeView(options);
        this.treeView.addEvent("loadChildren", this.onTreeNodeLoaded);
        this.treeView.load();

        itemEl = this.getElement("categorySelectSubmit");
        if (itemEl)
            itemEl.addOnClick(this.onSelectClicked);

        itemEl = this.getElement("categorySelectCancel");
        if (itemEl)
            itemEl.addOnClick(this.close);
    },

    onTreeNodeLoaded: function(parent) {
        if (!parent || (this.options.selectedCategories == null))
            return;

        var selected = this.options.selectedCategories.split(';');
        if (selected.contains(parent.name))
            parent.setCheckboxState("checked");

        var children = parent.getChildren();
        for (var i = 0; i < children.length; i++) {
            if (selected.contains(children[i].name))
                children[i].setCheckboxState("checked");
        }
    },

    onSelectClicked: function() {
        if (!this.treeView)
            return;

        if (this.options.multiSelect) {
            var checked = this.treeView.getChecked(null, true),
                selectedCategories = '',
                selectedCategoryIDs = '';

            for (var i = 0; i < checked.length; i++) {
                if (selectedCategories.length > 0)
                    selectedCategories += ';';
                if (selectedCategoryIDs.length > 0)
                    selectedCategoryIDs += ';';

                selectedCategories += checked[i].name;
                if (checked[i].data)
                    selectedCategoryIDs += checked[i].data.catid;
                else
                    selectedCategoryIDs += '-1';
            }
        } 
        else {
            var selected = this.treeView.getSelected(),
                selectedCategoryIDs = '',
                selectedCategories = '';
            if (selected) {
                selectedCategoryIDs = selected.id;
                selectedCategories = selected.name;
            }
        }

        this.options.selectedCategories = selectedCategories;
        this.options.selectedCategoryIDs = selectedCategoryIDs;

        this.close();
    },

    onClose: function() {
        if (this.treeView)
            this.treeView = null;

        this.parent();
    }
})